import moment from 'moment'
import * as Papa from 'papaparse';
export default {
  data: function () {
    return {
      productType: {
        uk: {
          pizza: 'pizza',
          deal: 'deal',
          side: 'side',
          dip: 'dip',
          dessert: 'dessert',
          drink: 'drink',
          crust: 'crust'
        }
      },
      client_uuid: {
        jp: '606dd890-1e5d-4898-853a-0ef434fff627',
        nz: '2f28344b-2d60-4754-8985-5c23864a3737',
        sg: '0dbf8474-326c-4bde-b021-ec9f535dd5e8',
        ph: '584a2076-9a82-41d0-b585-d63168dd61b0',
        kw: 'eb0b3aa0-4ab7-4c9b-8ef0-bc54bea84ca5',
        in: 'b609dbb1-183d-4d99-a34f-17896d5325ed',
        bz: '57950680-0208-4703-9e0b-c5a8cc45cf42',
        uk1: 'ced6be27-b7d7-438a-a95e-4b64a4037bed',
        pe: 'ec5ac276-872f-4257-bb55-cc20648d3d26',
        pr: 'df0d826e-d4c3-4c6e-acc5-48e72ef075ea',
        mx: 'e73194ae-309e-4f8e-81d7-ef95c3179d20',
        my: '236e3ed4-3038-441a-be5b-417871eb84d4',
        my2: '63b860e7-d2a9-4acc-a56c-fdda68ac3f2b',
        uk2: '1addca76-c7e4-4c91-a086-6ddcc01a5227'
      },
      client_tz: {
        jp: 'Asia/Tokyo',
        nz: 'Pacific/Auckland',
        sg: 'Asia/Singapore',
        ph: 'Asia/Manila',
        kw: 'Asia/Kuwait',
        in: 'Asia/Kolkata',
        bz: 'America/Sao_Paulo',
        uk1: 'Europe/London',
        pe: 'America/Lima',
        pr: 'America/Puerto_Rico',
        mx: 'America/Mexico_City',
        my: 'Asia/Kuala_Lumpur',
        my2: 'Asia/Kuala_Lumpur',
        uk2: 'Europe/London'
      },
      client_language: {
        'ced6be27-b7d7-438a-a95e-4b64a4037bed': 'en-gb'
      },
      image_help_info: {
        campaign: {
          background: {
            width: 3300,
            height: 1860,
            size: 500
          },
          desktop_thumbnail: {
            width: 235,
            height: 165,
            size: 200
          },
          desktop_detail: {
            width: 240,
            height: 760,
            size: 200
          }
        },
        topic: {
          desktop_thumbnail: {
            width: 235,
            height: 165,
            size: 200
          },
          desktop_detail: {
            width: 240,
            height: 760,
            size: 200
          }
        },
        banner: {
          desktop: {
            width: 235,
            height: 165,
            size: 200
          },
          mobile: {
            width: 240,
            height: 760,
            size: 200
          }
        },
        single: {
          desktop_thumbnail: {
            width: 235,
            height: 165,
            size: 200
          },
          desktop_detail: {
            width: 240,
            height: 760,
            size: 200
          },
          mobile_thumbnail: {
            width: 235,
            height: 165,
            size: 200
          },
          mobile_detail: {
            width: 470,
            height: 330,
            size: 200
          }
        },
        combo: {
          desktop_thumbnail: {
            width: 235,
            height: 165,
            size: 200
          },
          desktop_detail: {
            width: 540,
            height: 210,
            size: 200
          },
          mobile_thumbnail: {
            width: 235,
            height: 165,
            size: 200
          },
          mobile_detail: {
            width: 540,
            height: 210,
            size: 200
          }
        },
        category: {
          icon: {
            width: 180,
            height: 102,
            size: 200
          },
          banner: {
            width: 620,
            height: 125,
            size: 200
          }
        },
        coupon: {
          desktop: {
            width: 235,
            height: 165,
            size: 200
          },
          mobile: {
            width: 235,
            height: 165,
            size: 200
          }
        },
        menu_group: {
          desktop_thumbnail: {
            width: 235,
            height: 165,
            size: 200
          },
          desktop_detail: {
            width: 235,
            height: 165,
            size: 200
          },
          mobile_thumbnail: {
            width: 235,
            height: 165,
            size: 200
          },
          mobile_detail: {
            width: 235,
            height: 165,
            size: 200
          }
        },
        first_layer: {
          desktop_thumbnail: {
            width: 235,
            height: 165,
            size: 200
          },
          desktop_detail: {
            width: 235,
            height: 165,
            size: 200
          },
          mobile_thumbnail: {
            width: 235,
            height: 165,
            size: 200
          },
          mobile_detail: {
            width: 235,
            height: 165,
            size: 200
          }
        },
        second_layer: {
          desktop_thumbnail: {
            width: 235,
            height: 165,
            size: 200
          },
          desktop_detail: {
            width: 235,
            height: 165,
            size: 200
          },
          mobile_thumbnail: {
            width: 235,
            height: 165,
            size: 200
          },
          mobile_detail: {
            width: 235,
            height: 165,
            size: 200
          }
        },
        topping: {
          desktop_thumbnail: {
            width: 235,
            height: 165,
            size: 200
          },
          desktop_detail: {
            width: 235,
            height: 165,
            size: 200
          },
          mobile_thumbnail: {
            width: 235,
            height: 165,
            size: 200
          },
          mobile_detail: {
            width: 235,
            height: 165,
            size: 200
          }
        },
        menu_attribute: {
          icon: {
            width: 235,
            height: 165,
            size: 200
          }
        }
      },
      couponTypes: {
        FREE_ITEM: 1,
        DISCOUNT_UNIT: 2,
        DISCOUNT_PERCENT: 3,
        FREE_DELIVERY: 4,
        CIRCLE_DISCOUNT: 5,
        FREE_TOPPING: 6,
        CALL_CALLCENTER_TO_USE: 7
      },
      couponContants: {
        DISCOUNT_PERCENT_DECIMAL: 4
      }
    }
  },
  computed: {
    getCurrentYear () {
      return new Date().getFullYear()
    }
  },
  methods: {
    swapObject (obj) {
      let result = {}
      for (var key in obj) {
        result[obj[key]] = key
      }
      return result
    },
    convertDateTimeToUTC (datetime) {
      if (!datetime || datetime.indexOf('ASAP') >= 0) {
        return ''
      }
      return moment(datetime).utc().format('YYYY-MM-DD HH:mm:ss')
    },
    convertUTCToClientTime (datetime) {
      if (!datetime) {
        return ''
      }
      return moment.utc(datetime).local()
    },
    convertDateTimeToUTCWithToday (datetime) {
      let today = new Date()
      today = this.$moment(today).format('YYYY-MM-DD')
      datetime = today + ' ' + datetime
      if (!datetime || datetime.indexOf('ASAP') >= 0) {
        return ''
      }
      return moment(datetime).utc().format('HH:mm:ss')
    },
    convertUTCToTimeZone (datetime, timezone) {
      if (!timezone) {
        timezone = moment.tz.guess()
      }

      if (!datetime) {
        return moment.utc(new Date()).tz(timezone)
      }
      return moment.utc(datetime).tz(timezone)
    },
    removePropertiesNotExistObject (object, keys) {
      for (let p in object) {
        if (keys.indexOf(p) < 0) delete object[p]
      }
      return object
    },
    convertDateTimeToUTCWithADay (datetime) {
      if (!datetime || datetime.indexOf('ASAP') >= 0) {
        return ''
      }
      return moment(datetime).utc().format('HH:mm:ss')
    },
    compareDateTimeWithNow (datetime, timezone) {
      if (!datetime) {
        return false;
      }
      let strDateTime = datetime.replace('undefined', '00')
      const now = moment().tz(timezone)
      const date = moment(strDateTime.length < 17 ? `${strDateTime}:00` : strDateTime)
      return moment(date.format('YYYY-MM-DD HH:mm:ss')).isAfter(moment(now.format('YYYY-MM-DD HH:mm:ss')))
    },
    convertDateTimeToLocal (datetime, timezone, days = 0, format = 'YYYY-MM-DD') {
      if (!datetime) {
        const now = new Date()
        now.setDate(now.getDate() + days)
        return moment.utc(now).tz(timezone).format(format)
      }
      return moment(datetime).tz(timezone).format(format)
    },
    convertDateToDateTime (strDate) {
      const result = new Date(strDate)
      const yyyy = result.getFullYear()
      let mm = result.getMonth() + 1
      let dd = result.getDate()
      let hours = result.getHours()
      let minutes = result.getMinutes()
      let seconds = result.getSeconds()
      if (dd < 10) dd = '0' + dd
      if (mm < 10) mm = '0' + mm
      if (hours < 10) hours = '0' + hours
      if (minutes < 10) minutes = '0' + minutes
      if (seconds < 10) seconds = '0' + seconds
      return {
        date: yyyy + '-' + mm + '-' + dd,
        time: hours + ':' + minutes + ':' + seconds
      }
    },
    addDays (strDate, days) {
      const result = new Date(strDate)
      result.setDate(result.getDate() + days)
      const yyyy = result.getFullYear()
      let mm = result.getMonth() + 1
      let dd = result.getDate()
      if (dd < 10) dd = '0' + dd
      if (mm < 10) mm = '0' + mm
      return yyyy + '-' + mm + '-' + dd
    },
    getDaysOfWeek (date, days) {
      const result = new Date(date)
      result.setDate(date.getDate() + days)
      return result.getDay()
    },
    checkStartAndEndCalendar (item1, item2) {
      const startDate1 = new Date(item1.startRecur + ' ' + item1.startTime).getTime()
      const endDate1 = new Date(item1.endRecur + ' ' + item1.endTime).getTime()
      const startDate2 = new Date(item2.startRecur + ' ' + item2.startTime).getTime()
      const endDate2 = new Date(item2.endRecur + ' ' + item2.endTime).getTime()
      if ((startDate1 > startDate2 && startDate1 < endDate2) ||
        (endDate1 > startDate2 && endDate1 < endDate2) ||
        (startDate1 <= startDate2 && endDate2 <= endDate1) ||
        (startDate2 <= startDate1 && endDate1 <= endDate2)) {
        if ((item1.startTime >= item2.startTime && item1.startTime < item2.endTime) || (item1.endTime > item2.startTime && item1.endTime <= item2.endTime) || (item1.startTime <= item2.startTime && item1.endTime >= item2.endTime)) {
          return false
        }
      }
      return true
    },
    getImageHelpInfo (type, key) {
      return this.$t('message.image_tooltip', {
        type: 'JPEG,PNG',
        width: this.image_help_info[type][key].width,
        height: this.image_help_info[type][key].height,
        size: this.image_help_info[type][key].size
      })
    },
    /*
     * Format date range picker with multiple languages
    */
    format_date_range_locale () {
      let format = {
        direction: 'ltr',
        format: 'YYYY-MM-DD',
        cancelLabel: this.$t('common.cancel'),
        applyLabel: this.$t('common.apply'),
        daysOfWeek: [
          this.$t('date_range.sun'),
          this.$t('date_range.mon'),
          this.$t('date_range.tue'),
          this.$t('date_range.wed'),
          this.$t('date_range.thu'),
          this.$t('date_range.fri'),
          this.$t('date_range.sat')
        ],
        monthNames: [
          this.$t('date_range.month_1'),
          this.$t('date_range.month_2'),
          this.$t('date_range.month_3'),
          this.$t('date_range.month_4'),
          this.$t('date_range.month_5'),
          this.$t('date_range.month_6'),
          this.$t('date_range.month_7'),
          this.$t('date_range.month_8'),
          this.$t('date_range.month_9'),
          this.$t('date_range.month_10'),
          this.$t('date_range.month_11'),
          this.$t('date_range.month_12')
        ],
        customRangeLabel: 'Custom range',
        firstDay: 0,
        separator: ' - ',
        weekLabel: 'W'
      }
      return format
    },
    format_date_ranges () {
      let range =
      {
        [this.$t('common.today')]: [this.$moment(), this.$moment()],
        [this.$t('date_range.yesterday')]: [this.$moment().subtract(1, 'days'), this.$moment().subtract(1, 'days')],
        [this.$t('date_range.this_month')]: [this.$moment().startOf('month'), this.$moment().endOf('month')],
        [this.$t('date_range.this_year')]: [this.$moment().startOf('year'), this.$moment().endOf('year')],
        [this.$t('date_range.last_week')]: [this.$moment().subtract(1, 'week').startOf('week'), this.$moment().subtract(1, 'week').endOf('week')],
        [this.$t('date_range.last_month')]: [this.$moment().subtract(1, 'month').startOf('month'), this.$moment().subtract(1, 'month').endOf('month')]
      }
      return range
    },
    checkDSTTime (datetime, timezone) {
      if (timezone && timezone === 'America/Mexico_City') return false
      if (!datetime) {
        return moment.utc(new Date()).tz(timezone).isDST()
      }
      return moment.utc(datetime).tz(timezone).isDST()
    },
    convertDateTimeFromTimezoneToUTC (datetime, timezone) {
      if (!timezone) {
        return this.convertDateTimeToUTC(datetime)
      }
      if (!datetime) {
        return moment.tz(timezone).utc()
      }

      let chkdate = moment.tz(datetime, timezone)
      if (!chkdate.isValid()) {
        return moment.tz(timezone).utc()
      }
      return chkdate.utc()
    },
    checkPermission (userInfo, permission) {
      let modules = userInfo.modules ? userInfo.modules : {}
      if (modules.indexOf(permission) !== -1) {
        return true
      }
      return false
    },
    checkPermissionAdmin (userInfo, permission) {
      let adminIds = [1, 34, 35, 62]
      let modules = userInfo.modules ? userInfo.modules : {}
      if (adminIds.indexOf(userInfo.user_id) !== -1 || modules.indexOf(permission) !== -1) {
        return true
      }
      return false
    },
    isPastDate (date) {
      const currentDate = moment(new Date(), 'YYYY-MM-DD')
      return currentDate.diff(moment(date), 'days') > 0
    },
    /**
     * Check variable is empty
     * */
    isEmpty (param) {
      if (param == null) {
        return true
      }
      if (typeof param === 'object') {
        return Object.keys(param).length <= 0
      }

      if (typeof param === 'string') {
        return param.length <= 0
      }

      if (param instanceof Array) {
        return param.length <= 0
      }
      return false
    },
    setCacheLocalStorage (key, data, expireAmount = 5, expireUnit = 'minutes') {
      let now = moment()
      let dataStorage = {
        data: [],
        expired: null
      }

      if (data) {
        dataStorage.data = data
        dataStorage.expired = now.add(expireAmount, expireUnit).format('YYYY-MM-DD HH:mm:ss')
        localStorage[key] = JSON.stringify(dataStorage)
      }
    },
    getCacheLocalStorage (key) {
      let now = moment()
      let data = null
      let isExpired = false

      if (localStorage[key]) {
        let cachedData = JSON.parse(localStorage[key])
        let expired = moment(cachedData.expired, 'YYYY-MM-DD HH:mm:ss')
        data = cachedData.data

        if (now.isAfter(expired)) {
          isExpired = true
          localStorage.removeItem(key)
        }
      } else {
        isExpired = true
      }

      return {
        expired: isExpired,
        data: data
      }
    },
    checkValue (value) {
      if (value === null || value === undefined || value === '' || value === 'null' || value === 'undefined') {
        return false
      }
      return true
    },
    getValueFromAttr (item, attr, defaultValue) {
      if (!this.checkValue(item) || !this.checkValue(attr)) {
        return defaultValue
      }
      if (attr.indexOf('.') > -1) {
        const arrs = attr.split('.')
        let result = item
        for (let i = 0; i < arrs.length; i++) {
          result = result[arrs[i]]
          if (!this.checkValue(result)) {
            return defaultValue
          }
        }
        return result
      }
      if (!this.checkValue(item[attr])) {
        return defaultValue
      }
      return item[attr]
    },
    getArrsInArrs (value, data, attr) {
      const $this = this
      if (!this.checkValue(data) || !this.checkValue(attr)) {
        return []
      }
      const arrs = data.filter(function (item) {
        return $this.getValueFromAttr(item, attr) === value
      })
      return arrs
    },
    getObjectInArrs (value, data, attr) {
      const arrs = this.getArrsInArrs(value, data, attr)
      if (arrs.length > 0) {
        return arrs[0]
      }
      return null
    },
    isJapanMarket () {
      const JAPAN_UUID = '606dd890-1e5d-4898-853a-0ef434fff627'
      const clientUuid = localStorage.getItem('clientID')
      return clientUuid === JAPAN_UUID
    },
    validateCouponRegex (code) {
      if (this.isJapanMarket()) {
        return /^[a-zA-Z0-9<>@._#/]+$/g.test(code)
      }
      return /^[a-zA-Z0-9-<>@._#/]+$/g.test(code)
    },
    getCouponConfigByType (configType = '', key) {
      if (this.coupon == null) {
        return configType === 'show'
      }
      const config = this._.find(this.coupon.basic_info, { type: key })
      if (config == null) {
        return false
      }
      return config[configType]
    },
    extractJSON (str) {
      var firstOpen, firstClose, candidate
      firstOpen = str.indexOf('{', firstOpen + 1)
      do {
        firstClose = str.lastIndexOf('}')
        if (firstClose <= firstOpen) {
          return null
        }
        do {
          candidate = str.substring(firstOpen, firstClose + 1)
          try {
            var res = JSON.parse(candidate)
            return [res, firstOpen, firstClose + 1]
          } catch (e) { }
          firstClose = str.substr(0, firstClose).lastIndexOf('}')
        } while (firstClose > firstOpen)
        firstOpen = str.indexOf('{', firstOpen + 1)
      } while (firstOpen !== -1)
    },
    cleanArray (actual) {
      const newArray = []
      for (let i = 0; i < actual.length; i++) {
        if (actual[i]) {
          newArray.push(actual[i])
        }
      }
      return newArray
    },
    objectToParams (json) {
      if (!json) return ''
      return this.cleanArray(
        Object.keys(json).map(key => {
          if (json[key] === undefined) return ''
          return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
        })
      ).join('&')
    },
    validateDatetimeRange (startDate, endDate) {
      const DATE_FORMAT = 'DD-MM-YYYY'
      return moment(endDate, DATE_FORMAT).diff(moment(startDate, DATE_FORMAT), 'days') >= 0
    },
    formatPriceByTier (prices, tier) {
      let priceDefault = {}
      let formatPrice = {}
      for (let t in tier) {
        priceDefault[t] = 0
      }
      if (typeof prices === 'object' && prices !== null) {
        for (let i in tier) {
          if (prices[i] === undefined || prices[i] === null) {
            formatPrice[i] = 0
          } else {
            formatPrice[i] = prices[i]
          }
        }
        return formatPrice
      } else {
        return priceDefault
      }
    },
    isEmptyItemByLangArray (itemByLangArr) {
      if (this.isEmpty(itemByLangArr)) return true
      for (const lang in itemByLangArr) {
        if (!this.isEmpty(itemByLangArr[lang])) return false
      }
      return true
    },
    getDefaultDataFilter () {
      const data = {
        filter: this.filter,
        dataTable: {
          sort: {
            field: this.dataTable.sort.field,
            type: this.dataTable.sort.type
          },
          currentPage: this.dataTable.currentPage,
          perPage: this.dataTable.perPage
        }
      }
      return data
    },
    fetchDataFilter (keyName) {
      let data = this.$session.get(keyName, null)
      if (!data) return
      if ('filter' in data) {
        for (let i in data.filter) {
          this.filter[i] = data.filter[i]
        }
      }
      if ('dataTable' in data) {
        for (let i in data.dataTable) {
          this.dataTable[i] = data.dataTable[i]
        }
      }
    },
    preserveDataFilter (keyName, data) {
      const filter = 'filter' in data ? data.filter : null
      const dataTable = 'dataTable' in data ? data.dataTable : null
      this.$session.set(keyName, {
        filter,
        dataTable
      })
    },
    watchAndRefreshData (keyName, fn) {
      if (this.$session.get(keyName)) return this.$session.remove(keyName)
      return fn()
    },
    validatePriceCsv(file, menuPriceFields, schemas) {
      return new Promise((resolve, reject) => {
        let errors  = []
        let index = 0
        let is_missing_field = false
        const isFieldPass = (fields, fieldDefaults) => {
          let missingFields = []
          for( let i = 0; i < fieldDefaults.length; i++) {
            if(fields.length == 0 || fields.indexOf(fieldDefaults[i]) < 0) {
              missingFields.push(fieldDefaults[i])
            }
          }
          return missingFields
        }

        Papa.parse(file, {
          header: true,
          transformHeader: (col) => {
            return col.trim()
          },
          skipEmptyLines: true,
          step: (results, parser) => {
            const item = this._.get(results, 'data', null)
            if(!item) {
              errors.push('Row empty!')
              parser.abort()
            }
            if (0 == index) {
              const fields = this._.get(results, 'meta.fields', null)
              const missingFields = isFieldPass(fields, menuPriceFields)
              if(missingFields.length > 0) {
                errors.push(missingFields.join(', '))
                is_missing_field = true
                parser.abort()
              }
            }
            try {
              schemas.validateSync(item)
            } catch (errs) {
              errors = errors.concat(errs.errors.map((err) => err))
              parser.abort()
            }

            index++;
          },
          complete: (results, file) => {
            resolve({ is_empty: 0 === index, is_missing_field, errors })
          },
          error: () => {
            resolve({ is_empty: 0 === index, is_missing_field, errors })
          }
        })
      });
    },
    checkShowLateDelivery () {
      if (this.order == null) {
        return false
      }
      let config = this._.find(this.order.list, function (o) {
        return o.type === 'show_late_delivery'
      })
      if (config == null) {
        return false
      }
      return config.show
    },
    checkShowJPGiftCard () {
      if (this.order == null) {
        return false
      }
      let config = this._.find(this.order.list, function (o) {
        return o.type === 'show_jp_gift_card'
      })
      if (config == null) {
        return false
      }
      return config.show
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/index.js